var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.data.components),function(component,index){return _c('VModule',{key:index,attrs:{"data":component,"index":index}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }